<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle"></span>
        <h3 class="page-title">Laporan Kehadiran Circle Doa</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card mb-4">
          <div class="card-body p-1 pb-3" style="overflow-x:scroll">
            <d-row style="margin:auto">
              <d-col md="6"  class="form-group">
                <label for="feSearch">Tanggal</label>
                  <d-datepicker v-model.trim="reportdate"></d-datepicker>
              </d-col>
            </d-row>
            <br/><br/>
            <d-row style="margin:auto">
              <d-col md="6"  class="form-group">
                <label for="feGo">&nbsp;</label>
                <button type="button" class="btn-primary" @click="update_data"><i class="material-icons">send</i> Kirim</button>
                <label v-if="show_excel" for="feGo">&nbsp;</label>
                <button v-if="show_excel" type="button" class="btn-primary is-hidden-mobile" @click="xls"><i class="material-icons">border_all</i> Excel</button>
              </d-col>
            </d-row>
            <d-row>
            <d-col md="6"  class="form-group">
            </d-col>
            </d-row>
        <b-table
            id="dtable"
            :data="isEmpty ? [] : data"
            :loading="loading"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            >

            <template slot-scope="props">
                <b-table-column field="date" label="No" >
                    {{ props.row.idx }}
                </b-table-column>
                <b-table-column field="date" label="Tanggal" >
                    {{ props.row.date }}
                </b-table-column>
                <b-table-column field="id" label="Circle" >
                    <span class="tag is-success">
                    {{ props.row.id }}
                    </span>
                </b-table-column>
                <b-table-column field="fullname" label="Jumlah Peserta" >
                    {{ props.row.fullname }}
                </b-table-column>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>No result</p>
                    </div>
                </section>
            </template>
        </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from '../env.vue';
import FileSaver from 'file-saver'

    export default {
        components: {
        },
        data() {
            return {
                sortField:'id',
                sortOrder:'asc',
                data:[],
                isEmpty: false,
                reportdate: '',
                loading: false,
                hasMobileCards: false,
                sortIcon:'arrow-up',
                sortIconSize:'is-small',
                defaultSortOrder:'desc',
                search:'',
                show_excel:false,
                opened:[],
            }
        },
        watch:{
        },
        methods:{
          xls(){
    var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';

    tab_text = tab_text + '<x:Name>List Kehadiran Circle Doa</x:Name>';
    tab_text = tab_text + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
    tab_text = tab_text + "<table>";
    tab_text = tab_text + document.getElementById('dtable').childNodes[4].childNodes[0].innerHTML;
    tab_text = tab_text + '</table></body></html>';
    var file = new Blob([tab_text], {type: 'application/vnd.ms-excel;charset=utf-8;'});
    FileSaver.saveAs(file,'list_kehadiran_circle_doa.xls')
          },
          update_data(){
           this.loading=true;
           if (this.reportdate=='') {
               alert('Harap pilih tanggal');return
           }
              console.log('reportdate',this.reportdate)
           let dtmp = this.reportdate.split('-');
           this.axios.post( env.server+'/attendance-circle-list',{
             date: dtmp[0]+'-'+dtmp[1]+'-'+dtmp[2],

           }).then(
             resp=>{
               resp.data=JSON.parse(resp.data);
               this.loading=false;
                 console.log('data',resp.data)
               this.data=resp.data.data;
               this.show_excel=true;
               for(let i=0;i<this.data.length;i++) this.data[i].idx=i+1;
             }
           );
          },
        },
        mounted(){  
          var dt = new Date();
          this.reportdate=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
        },
    }
</script>
